import { type JobStatus } from "@vidario/domain";
import { type ReactElement } from "react";

import { cn } from "../utils/cn";

export type { JobStatus };

export const JOB_STATUS_MAP: Record<JobStatus, { label: string; classes: string }> = {
  draft: {
    label: "Entwurf",
    classes: "bg-[var(--job-status-draft-bg)] text-[var(--job-status-draft-fg)]",
  },
  kandidatensuche: {
    label: "Kandidatensuche",
    classes:
      "bg-[var(--job-status-kandidatensuche-bg)] text-[var(--job-status-kandidatensuche-fg)]",
  },
  longlist: {
    label: "Longlist",
    classes: "bg-[var(--job-status-longlist-bg)] text-[var(--job-status-longlist-fg)]",
  },
  outreaching: {
    label: "Qualifizierung",
    classes: "bg-[var(--job-status-outreaching-bg)] text-[var(--job-status-outreaching-fg)]",
  },
  empfehlung: {
    label: "Empfehlung",
    classes: "bg-[var(--job-status-empfehlung-bg)] text-[var(--job-status-empfehlung-fg)]",
  },
  placed: {
    label: "Platziert",
    classes: "bg-[var(--job-status-placed-bg)] text-[var(--job-status-placed-fg)]",
  },
  closed: {
    label: "Geschlossen",
    classes: "bg-[var(--job-status-closed-bg)] text-[var(--job-status-closed-fg)] line-through",
  },
};

export interface JobStatusBadgeProps {
  status: JobStatus;
  className?: string;
}

export function JobStatusBadge({ status, className }: JobStatusBadgeProps): ReactElement {
  const cfg = JOB_STATUS_MAP[status];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium",
        cfg.classes,
        className,
      )}
    >
      {cfg.label}
    </span>
  );
}
